import { BarcodeActionTypes, BarcodeActions } from './types';
import { Barcode, BarcodeKitStatus } from '../../models/barcode';

const initialState: Barcode = {
  barcode: '',
  kitId: '',
  status: BarcodeKitStatus.OPEN,
  error: undefined,
};

const barcodeReducers = (state = initialState, action: BarcodeActions) => {
  switch (action.type) {
    case BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT:
      return {
        ...state,
      };
    case BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT_SUCCESS:
      return {
        ...state,
        kitId: action.payload.kitId,
        status: action.payload.status,
        barcode: action.payload.barcode,
        error: undefined,
      };
    case BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT_ERROR:
      return {
        ...state,
        error: action.error,
      };
  }
  return state;
};

export default barcodeReducers;